import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import OffersPage from "./pages/OffersPage";
import OrdersPage from "./pages/OrdersPage";
import TeamsPage from "./pages/TeamsPage";
import PlanningPage from "./pages/PlanningPage";
import SettingsPage from "./pages/SettingsPage";
import ClosedOrdersPage from "./pages/ClosedOrdersPage";
import ServicePage from "./pages/ServicePage";
import UsersPage from "./pages/UsersPage";
import AuditTrailPage from "./pages/AuditTrailPage";
import { isAdmin } from "./utils/roles";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7] dark:bg-[#0f172a]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#00CBA9] border-t-transparent animate-spin rounded-full mx-auto mb-4"></div>
          <p className="text-sm text-[#64748b]">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#00CBA9] border-t-transparent animate-spin rounded-full" />
      </div>
    );
  }

  if (!isAdmin(user)) {
    return <Navigate to="/offers" replace />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/offers" replace />} />
                <Route path="offers" element={<OffersPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="closed-orders" element={<ClosedOrdersPage />} />
                <Route path="teams" element={<TeamsPage />} />
                <Route path="planning" element={<PlanningPage />} />
                <Route path="service" element={<ServicePage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route
                  path="admin/users"
                  element={
                    <AdminRoute>
                      <UsersPage />
                    </AdminRoute>
                  }
                />
                <Route
                  path="admin/audit"
                  element={
                    <AdminRoute>
                      <AuditTrailPage />
                    </AdminRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
